"use strict";
/// <reference path="irep.js"/>

IREP.SixthGen = (function () {
    var init = function () {
        $("#OpenToggle").click(function () {
            $("#Open").slideToggle("slow");
        });
        bannerRotator("#slider", 300, 11000, true);





        $(function () {
            var carousel = $('#slider ul');
            var carouselChild = carousel.find('li');
            var clickCount = 0;
            var selector = '#slider';
            var count = $(selector + " li").size(); //get total number of list items
            var itemWidth = carousel.find('li:first').width() + 1; 


            carousel.width(itemWidth * carouselChild.length);



                       
            $('.btnNext').click(function () {

                var currentClass = $(selector + " li:visible").attr('rel'); //get the list position of the current image
                var nextClass = $(selector + " li:visible").attr('rel'); //open a new variable for the next class
                if (currentClass == count) { nextClass = 1; } //if you've reached the end of the images... start from number 1 again
                else { nextClass++; } //if not just add one to the last number

                $(selector + " li[rel=" + currentClass + "]").fadeOut(300); //fade out old image
                $("#bannerNav a.active").removeClass('active'); //remove active class from our nav

                $(selector + " li[rel=" + nextClass + "]").fadeIn(300); //fade in new image
                $("#bannerNav a[rel=" + nextClass + "]").addClass('active'); //add new active class to the next nav item
                

            });

            $('.btnPrevious').click(function () {
                var currentClass = $(selector + " li:visible").attr('rel'); //get the list position of the current image
                var nextClass = $(selector + " li:visible").attr('rel'); //open a new variable for the next class
                if (currentClass == 1) { nextClass = count; } //if you've reached the end of the images... start from number 1 again
                else { nextClass--; } //if not just add one to the last number

                $(selector + " li[rel=" + currentClass + "]").fadeOut(300); //fade out old image
                $("#bannerNav a.active").removeClass('active'); //remove active class from our nav

                $(selector + " li[rel=" + nextClass + "]").fadeIn(300); //fade in new image
                $("#bannerNav a[rel=" + nextClass + "]").addClass('active'); //add new active class to the next nav item

            });

            //function refreshChildPosition() {
            //    carouselChild.each(function () {
            //        $(this).css('left', itemWidth * carouselChild.index($(this)));
            //    });
            //}

            //function refreshChildPositionNext() {
            //    carouselChild.each(function () {
            //        leftVal = parseInt($(this).css('left'));
            //    });
            //}
        });


        $('.iconBullets').waypoint(function () {
            TweenLite.to($('#windows2in1'), .25, { left: "-160px" });
        },
        {
            triggerOnce: true
        });

        $('.btnPrevious').waypoint(function () {
            TweenLite.set($('#corem3, #core3,#core7, #corem7'), { scale: ".7", transformOrigin:"50% 50%" });
            TweenLite.to($('#corem3, #core3,#core7, #corem7'), 2, { scale: "1", delay: .1, transformOrigin: "50% 50%", ease:Elastic.easeOut, });
            TweenLite.set($('#corem5, #core5'), { scale: ".7", transformOrigin:"50% 50%" });
            TweenLite.to($('#corem5, #core5'), 2, { scale: "1", transformOrigin: "50% 50%", ease: Elastic.easeOut, });
        }
            ,
        {
            triggerOnce: true
        });

    }


    return {
        init: init
    };


})();
